// Which scoreboard is the one that goes dark.
//
// The standings used to stay live right up to the final wine, and only the very
// last round was hidden — one round of suspense, arriving with no warning. A
// stretch of blackout is a much better ending, and it only works if the room is
// TOLD it is happening: a scoreboard that quietly stops appearing reads as a
// bug, while a scoreboard that visibly goes dark is the last beat before the
// finale. The board that goes dark is the last one with two questions still to
// play in front of it — see the generator for why one is not enough.
//
// The flow says which board that is. This used to be DERIVED here at runtime,
// which had the side effect of reaching every game — including sessions already
// created and boxes already sold, whose flow was fixed the day they were made.
// Mel's call (2026-09-01) is that it applies to new games only, so the decision
// moved to session creation: apps/admin/src/components/markScoreboardBlackout.js
// writes `blackout: true` onto the step, and this reads nothing else. A session
// carries its flow_steps from the moment it is created, so an older game simply
// has no flag and plays exactly as it always did.
//
// Keep this a flag read. Adding a derivation fallback here for "flows that
// weren't marked" would put the old behaviour straight back on every existing
// session, which is the thing this change exists to prevent.

/** Steps that hold live standings. */
const SCOREBOARD = 'scoreboard';

/**
 * Is this step the scoreboard that goes dark?
 *
 * @param {Array<{type: string, blackout?: boolean}>} flowSteps  the session's full flow
 * @param {number} stepIndex                                     the step being rendered
 * @returns {boolean}
 */
export function isScoreboardBlackout(flowSteps, stepIndex) {
  if (!Array.isArray(flowSteps) || typeof stepIndex !== 'number') return false;
  const step = flowSteps[stepIndex];
  if (step?.type !== SCOREBOARD) return false;
  return step.blackout === true;
}
